<style>
  .loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<div class="loader-overlay" *ngIf="isLoading() | async">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
  </div>
</div>
